import * as React from 'react'

import { useTransmit } from '../../TransmitContext'
import {
  DefaultContent,
  StragglerUserContent,
  BlockedLockoutContent,
  PasswordLockoutContent,
  AuthSessionExpiredContent,
  DeceasedUserOrUsernameBlockedContent,
  AdditionalSecuritySetupRequiredContent,
  RSABlackListContent,
  EmailSunsetFinalSwitch,
} from './Content'
import log from '../../whisper'

export const TemporarilyUnavailable: React.FC = () => {
  const { activeScreen } = useTransmit()

  if (activeScreen.type !== 'TemporarilyUnavailable') {
    return <DefaultContent />
  }

  const { error, errorMode } = activeScreen.payload

  if (error) {
    switch (error) {
      case 'CIAM_E02_03_001': // CIAM-12602 Email Sunset "final switch"
        return <EmailSunsetFinalSwitch />
      default:
        // Log the error and let fall through to switch case below
        log.error({
          message: [`Unknown error code returned from transmit: ${error}`],
        })
    }
  }

  switch (errorMode) {
    case 'Locked':
      return <PasswordLockoutContent />
    case 'BlockedDeceased':
      return <DeceasedUserOrUsernameBlockedContent />
    case 'Straggler':
      return <StragglerUserContent />
    case 'Blocked':
      return <BlockedLockoutContent />
    case 'OTPIncorrect':
      return <BlockedLockoutContent />
    case 'AdditionalSecuritySetupRequired':
      return <AdditionalSecuritySetupRequiredContent />
    case 'AuthSessionExpired':
      return <AuthSessionExpiredContent />
    case 'RSABlackList':
      return <RSABlackListContent />
    case 'Default':
    default:
      return <DefaultContent />
  }
}
